module.exports = __webpack_public_path__ + "static/kroger-intro-img-01-5f28098b613a0a269459fdf1ac43aa1b.png";